module.exports = __webpack_public_path__ + "img/HY3703-156.6396d7cc.jpg";